import { c as _c } from "react/compiler-runtime";
import { Divider } from '@onefootprint/ui';
import type React from 'react';
type SectionProps = {
  title: string;
  children: React.ReactNode;
  id?: string;
  titleSuffix?: React.ReactNode;
  suffixActions?: React.ReactNode;
};
const Section = t0 => {
  const $ = _c(14);
  const {
    children,
    title,
    id,
    titleSuffix,
    suffixActions
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <h2 className="text-heading-5">{title}</h2>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1 || $[3] !== titleSuffix) {
    t2 = <div className="flex items-baseline gap-2">{t1}{titleSuffix}</div>;
    $[2] = t1;
    $[3] = titleSuffix;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== suffixActions || $[6] !== t2) {
    t3 = <header className="flex flex-wrap items-end justify-between gap-2 mb-2">{t2}{suffixActions}</header>;
    $[5] = suffixActions;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Divider className="mb-4" />;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== children || $[10] !== id || $[11] !== t3 || $[12] !== title) {
    t5 = <section aria-label={title} id={id} data-testid={id}>{t3}{t4}{children}</section>;
    $[9] = children;
    $[10] = id;
    $[11] = t3;
    $[12] = title;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
export default Section;